import React from 'react'
import RenderOkForm from '../RenderOkForm'

export default function OkTypedComponent({ outerProps, refField, itemList, ...compRender }) {
    return (
        <RenderOkForm refField={refField} key={compRender.field} okComp={compRender} itemList={itemList} />
    )
}

